module.exports = __webpack_public_path__ + "img/apptu1.96431307.png";